import { render, staticRenderFns } from "./TrajetDashboard.vue?vue&type=template&id=5ef8d0de&scoped=true"
import script from "./TrajetDashboard.vue?vue&type=script&lang=js"
export * from "./TrajetDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef8d0de",
  null
  
)

export default component.exports